import type { Dispatch, FC, SetStateAction } from "react";

import { Stack } from "@mui/material";
import CustomTextField from "../../../CustomTextField";

import { useTranslation } from "react-i18next";

interface SettingsTabOrderAndRegistrationsCaseProps {
  text?: string;
  setText?: Dispatch<SetStateAction<string>>;
}

export const SettingsTabOrderAndRegistrationsCase: FC<
  SettingsTabOrderAndRegistrationsCaseProps
> = ({ text, setText }) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction='column'
      sx={{
        pt: 1,
        gap: 1.5,
        py: 2,
      }}
    >
      <CustomTextField
        fullWidth
        label={
          t("campaign.notifications.settings.displayRules.notificationText") ??
          ""
        }
        value={text ?? ""}
        onChange={e => {
          if (setText) {
            setText(e.currentTarget.value);
          }
        }}
      />
    </Stack>
  );
};
